module.exports = __webpack_public_path__ + "img/9b070f0.jpeg";